import Swal from "sweetalert2";
import config from "../../config";
import {
    CLEAR_BOOKINGS,
    CLEAR_CHAT,
    CLEAR_FAVORITES,
    CLEAR_NOTIFICATIONS,
    CLEAR_PAYMENT_METHODS,
    CLEAR_WALLET_HISTORY,
    LOGIN,
    LOGOUT,
    START_LOADER,
    STOP_LOADER,
    UPDATE_PROFILE,
} from "./types";

export const LoginAction = (email, password) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADER });
        const data = JSON.stringify({ email, password });
        const res = await config.postApi(
            config.services.login(),
            config.defaultHeaders,
            data,
            email
        );
        dispatch({ type: STOP_LOADER });
        if (res) {
            dispatch({
                type: LOGIN,
                payload: {
                    user: res.response.data.user,
                    token: res.response.data.token,
                    loggedIn: true,
                },
            });
        }
    } catch (e) {
        dispatch({ type: STOP_LOADER });
        if (e.message == "You Must Verify Your Email") {
            const { isConfirmed } = await Swal.fire({
                icon: "error",
                title: "Oh Snap :(",
                html:
                    "Something went wrong, Please check below<br/><strong>" +
                    e +
                    "</strong>",
                confirmButtonText: "Resend Email",
                showCancelButton: true,
            });
            if (isConfirmed) {
                dispatch({ type: START_LOADER });
                const res = await config.postApi(
                    config.services.resendEmail(),
                    config.defaultHeaders,
                    JSON.stringify({ email }),
                    email
                );
                dispatch({ type: STOP_LOADER });
                if (res) {
                    Swal.fire({
                        icon: "success",
                        title: "Email Sent",
                        text: "Verification Email Sent!",
                    });
                }
            }
        }
        console.log(e.message);
    }
};

export const SocialLoginAction =
    (first_name, last_name, email = null, social_id, profile_picture = null) =>
    async (dispatch, getState) => {
        try {
            dispatch({ type: START_LOADER });
            const headers = config.defaultHeaders;
            const data = JSON.stringify({
                first_name: first_name,
                last_name: last_name,
                email: email,
                profile_picture: profile_picture,
                social_id: social_id,
            });
            const res = await config.postApi(
                config.services.socialLogin(),
                headers,
                data
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                let loggedIn = res.response.data.user.bio ? true : false;
                dispatch({
                    type: LOGIN,
                    payload: {
                        user: res.response.data.user,
                        token: res.response.data.token,
                        loggedIn: loggedIn,
                    },
                });
            }
        } catch (e) {
            console.log(e);
        }
    };

export const RegisterAction =
    (
        first_name,
        last_name,
        zip,
        email,
        password,
        confirm_password,
        hear_about
    ) =>
    async (dispatch) => {
        try {
            dispatch({ type: START_LOADER });
            const data = JSON.stringify({
                first_name,
                last_name,
                email,
                password,
                confirm_password,
                hear_about,
                zip,
            });
            const res = await config.postApi(
                config.services.register(),
                config.defaultHeaders,
                data
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                dispatch({
                    type: LOGIN,
                    payload: {
                        user: res.response.data.user,
                        token: res.response.data.token,
                        loggedIn: false,
                    },
                });
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
        }
    };

export const AddServicesAction =
    (service_ids, sparse = false) =>
    async (dispatch, getState) => {
        try {
            dispatch({ type: START_LOADER });
            const token = getState().auth.token;
            const headers = config.bearerHeaders(token);
            const res = await config.postApi(
                config.services.careGiverStep1(),
                headers,
                JSON.stringify({ services: service_ids, sparse })
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                dispatch({
                    type: UPDATE_PROFILE,
                    payload: res.response.data,
                });
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
        }
    };

export const UpdateServicesAction =
    (payload, cb) => async (dispatch, getState) => {
        try {
            dispatch({ type: START_LOADER });
            const token = getState().auth.token;
            const headers = config.bearerHeaders(token);
            const res = await config.postApi(
                config.services.careGiverStep2(),
                headers,
                JSON.stringify(payload)
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                dispatch({
                    type: UPDATE_PROFILE,
                    payload: res.response.data,
                });
                cb();
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
        }
    };

export const DeleteServicesAction =
    (service_id) => async (dispatch, getState) => {
        try {
            dispatch({ type: START_LOADER });
            const token = getState().auth.token;
            const headers = config.bearerHeaders(token);
            const res = await config.postApi(
                config.services.deleteService(service_id),
                headers
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                dispatch({
                    type: UPDATE_PROFILE,
                    payload: res.response.data,
                });
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
        }
    };
export const CreateProfileAction = (payload) => async (dispatch, getState) => {
    return new Promise(async (resolve, rej) => {
        try {
            dispatch({ type: START_LOADER });
            const token = getState().auth.token;
            const headers = config.multipartBearerHeaders(token);
            const res = await config.postApi(
                config.services.careGiverStep3(),
                headers,
                payload
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                dispatch({
                    type: UPDATE_PROFILE,
                    payload: res.response.data,
                });
                resolve();
            } else {
                rej();
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
            rej();
        }
    });
};

export const UpdatePasswordAction =
    (currentPassword, newPassword, confirmNewPassword) =>
    async (dispatch, getState) => {
        try {
            dispatch({ type: START_LOADER });
            const headers = config.bearerHeaders(getState().auth.token);
            console.log(headers);
            const data = JSON.stringify({
                current_password: currentPassword,
                password: newPassword,
                confirm_password: confirmNewPassword,
            });
            const res = await config.postApi(
                config.services.changePassword(),
                headers,
                data
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                Swal.fire({
                    title: "Success",
                    text: "Password Changed!",
                    icon: "success",
                });
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
        }
    };

export const UpdateProfileAction = (payload) => async (dispatch, getState) => {
    try {
        dispatch({ type: START_LOADER });
        let headers = config.multipartBearerHeaders(getState().auth.token);
        const res = await config.postApi(
            config.services.updateProfile(),
            headers,
            payload
        );
        dispatch({ type: STOP_LOADER });
        if (res) {
            dispatch({
                type: UPDATE_PROFILE,
                payload: res.response.data,
            });
        }
    } catch (e) {
        console.log(e);
        dispatch({ type: STOP_LOADER });
    }
};

export const UpdateServiceAction =
    (service_id, payload) => async (dispatch, getState) => {
        try {
            dispatch({ type: START_LOADER });
            const headers = config.bearerHeaders(getState().auth.token);
            const res = await config.postApi(
                config.services.updateService(service_id),
                headers,
                payload
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                dispatch({
                    type: UPDATE_PROFILE,
                    payload: res.response.data,
                });
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
        }
    };

export const ForgotPasswordAction =
    (email, cb) => async (dispatch, getState) => {
        try {
            dispatch({ type: START_LOADER });
            const url = config.services.forgotPassword();
            const headers = config.defaultHeaders;
            const res = await config.postApi(
                url,
                headers,
                JSON.stringify({ email })
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                Swal.fire({
                    icon: "success",
                    title: "Forgot Password",
                    text: "Forgot Password Email Sent! Don't forget to check the Spam folder as well!",
                }).then(cb);
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
        }
    };

export const VerifyResetCode = (code, cb) => async (dispatch, getState) => {
    try {
        dispatch({ type: START_LOADER });
        const res = await config.postApi(
            config.services.verifyCode(),
            config.defaultHeaders,
            JSON.stringify({ code })
        );
        dispatch({ type: STOP_LOADER });
        if (res) {
            Swal.fire({
                icon: "success",
                title: "Forgot Password",
                text: "Code Verified!",
            }).then(cb);
        }
    } catch (e) {
        dispatch({ type: STOP_LOADER });
        console.log(e);
    }
};

export const ResetPasswordAction =
    (email, code, password, confirm_password, cb) =>
    async (dispatch, getState) => {
        try {
            dispatch({ type: START_LOADER });
            const res = await config.postApi(
                config.services.resetPassword(),
                config.defaultHeaders,
                JSON.stringify({
                    email,
                    code,
                    token: code,
                    password,
                    confirm_password,
                })
            );
            dispatch({ type: STOP_LOADER });
            if (res) {
                Swal.fire({
                    icon: "success",
                    title: "Forgot Password",
                    text: "Password Changed Successfully!",
                }).then(cb);
            }
        } catch (e) {
            dispatch({ type: STOP_LOADER });
            console.log(e);
        }
    };

export const GetInfo = () => async (dispatch, getState) => {
    try {
        const res = await config.getApi(
            config.services.userInfo(),
            config.bearerHeaders(getState().auth.token)
        );
        if (res) {
            dispatch({ type: UPDATE_PROFILE, payload: res.response.data });
        }
    } catch (e) {
        console.log(e);
    }
};

export const AddDocuments = (docs) => async (dispatch, getState) => {
    try {
        dispatch({ type: START_LOADER });
        let headers = {
            Authorization: "Bearer " + getState().auth.token,
            Accept: "application/json",
        };
        let data = new FormData();
        for (let i = 0; i < docs.length; i++) {
            data.append("documents[]", docs[i]);
        }
        const res = await config.postApi(
            config.services.documments(),
            headers,
            data
        );
        dispatch({ type: STOP_LOADER });
        if (res) {
            dispatch({ type: UPDATE_PROFILE, payload: res.response.data.user });
        }
    } catch (e) {
        dispatch({ type: STOP_LOADER });
        console.log(e);
    }
};

export const DeleteDocument = (doc_id) => async (dispatch, getState) => {
    try {
        dispatch({ type: START_LOADER });
        const headers = config.bearerHeaders(getState().auth.token);
        const res = await config.deleteApi(
            `${config.services.documments()}/${doc_id}`,
            headers
        );
        dispatch({ type: STOP_LOADER });
        if (res) {
            dispatch({ type: UPDATE_PROFILE, payload: res.response.data.user });
        }
    } catch (e) {
        dispatch({ type: STOP_LOADER });
        console.log(e);
    }
};

export const LogoutAction = () => (dispatch) => {
    dispatch({
        type: CLEAR_BOOKINGS,
    });
    dispatch({
        type: CLEAR_CHAT,
    });
    dispatch({
        type: CLEAR_FAVORITES,
    });
    dispatch({
        type: CLEAR_PAYMENT_METHODS,
    });
    dispatch({
        type: CLEAR_WALLET_HISTORY,
    });
    dispatch({
        type: CLEAR_NOTIFICATIONS,
    });
    dispatch({
        type: LOGOUT,
    });
};
